module.exports = __webpack_public_path__ + "static/unified_data_icon-63d03f500d65a0545dc54f356faf4b56.svg";